var map = {
	"./more-react-native-components/more-react-native-components.js": 205,
	"./state-management/state-management.js": 206,
	"./text-input/text-input.js": 207
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 495;



//////////////////
// WEBPACK FOOTER
// ./presentations ^\.\/.*\.js$
// module id = 495
// module chunks = 72481519496252